export default __webpack_public_path__ + "static/media/Lotfi.54783133.png";